module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAK5JREFUOE/NksENwjAMRZ8l2CNsQieh7EAPOVFOPrQ7lE1gE7oHSEVNWimIhAj10kg+xPJ/8rctLHyyUM/aAdqcQUp4Fljbx+ymLWjbwVCCTMI4JA7Q5gbsgQJePWzHP7FOvgGh2FZ3p1M1sOlADAxH5jwEW/hRFEAOfibDFVtdxrzvICeep+frPiDixWmP0UNz26EeQ9D24YrsaffXVU4Q30Fix1mgqln7KWc9wBtCA0HhbIZg5wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/up.png
// module id = aH6s
// module chunks = 1